import React, { ReactNode } from 'react';
import { Typography } from '../../../../../../wag-react/components/Typography';
import { Divider } from '../../../../../../wag-react/core-components/divider';
import { Grid } from '../../../../../../wag-react/core-components/grid';
import { Box, BoxProps } from '../../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
import { Image } from '../../../../../../wag-react/next-components/image';
import { WellnessLabel } from '../WellnessLabel';
import { WellnessPlanPriceSection } from './WellnessPlanPriceSection';
export type WellnessPlanProps = {
  buttonHref: string;
  description: string;
  benefits: Record<string, string | ReactNode>;
  icon: string;
  iconAlt: string;
  label?: string;
  price: number;
  title: string;
  styles?: Record<string, unknown>;
} & BoxProps;
export const WellnessPlan = ({
  buttonHref,
  description,
  benefits,
  icon,
  iconAlt,
  label,
  price,
  title,
  styles,
  ...rest
}: WellnessPlanProps) => <Flex flex={1} flexDirection="column" justifyContent="space-between" py={[0, null, 3, null]} position="relative" my={['24px', null, 'unset']} borderLeft={['initial', null, '2px solid #e8e8e8']} {...styles} {...rest} data-sentry-element="Flex" data-sentry-component="WellnessPlan" data-sentry-source-file="index.tsx">
    {label && <WellnessLabel text={label} />}

    <Box px={['unset', null, '16px']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Grid gridTemplateColumns="1fr 40px" gridTemplateRows="50px 1fr" gridGap="8px" width={1} p={['16px', null, 'unset']} backgroundColor={['#EDEDED', null, 'unset']} borderRadius={['12px 12px 0 0', null, 'initial']} height="195px" data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        <Typography variant="h3" color="#4669B2" fontSize="26px" fontFamily="muliBold" m={0} style={{
        alignSelf: 'center'
      }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {title}
        </Typography>

        <Image src={icon} alt={iconAlt} alignSelf="center" height="42px" width="42px" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

        <Typography m={0} mb="16px" style={{
        gridColumn: '1 / 3'
      }} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {description}
        </Typography>
      </Grid>

      <Box border={['1px solid #D1D1D1', null, 'unset']} borderTop="unset" borderRadius={['0 0 12px 12px']} p={['16px', null, 'unset']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {Object.keys(benefits).map(key => <Box key={key} minHeight="40px" p="8px" borderTop="1px solid #EDEDED">
            <Typography fontSize="16px" m={0} textAlign="center">
              {benefits[key]}
            </Typography>
          </Box>)}
        <Flex display={['flex', null, 'none']} flexDirection="column" width={1} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Divider width={1} data-sentry-element="Divider" data-sentry-source-file="index.tsx" />

          <WellnessPlanPriceSection value={{
          price,
          buttonHref
        }} data-sentry-element="WellnessPlanPriceSection" data-sentry-source-file="index.tsx" />
        </Flex>
      </Box>
    </Box>
    <Flex display={['none', null, 'flex']} flexDirection="column" px="16px" width={1} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Divider width={1} data-sentry-element="Divider" data-sentry-source-file="index.tsx" />

      <WellnessPlanPriceSection value={{
      price,
      buttonHref
    }} data-sentry-element="WellnessPlanPriceSection" data-sentry-source-file="index.tsx" />
    </Flex>
  </Flex>;